import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StorageService } from '../../services/storage/storage.service';
@Component({
    standalone: true,
    imports: [CommonModule],
    selector: 'wd-simple-layout',
    templateUrl: './simple-layout.component.html',
    styleUrls: ['./simple-layout.component.css'],

})
export class SimpleLayoutComponent {
	@Input() label = '';
	showList = false;
	listWidth = 180;

	constructor(private storage: StorageService) {
		this.storage.get("showList").then(val => this.showList = !!val);
		this.storage.get("listWidth").then(val => {
			if (val && typeof val === 'number') this.listWidth = val;
		});
	}

	toggleShowList() {
		this.showList = !this.showList;
		this.storage.setSync("showList", this.showList);
	}
}
